module.exports = __webpack_public_path__ + "static/media/scribe.96f2ea6a.png";